import { installRuntimePolyfills } from "./polyfills";
import { initializeSupportBrowserDiagnosticHistory } from "./admin-pages/user-admin-pages/admin_support/threads_support/customer_chat_panel/supportBrowserDiagnosticHistory";
import { handleAppEntryImportFailure } from "./entry-failure";
import {
  initializeVitePreloadErrorRecovery,
} from "./utils/vite-preload-error-recovery";
import { initializeStartupProfiling } from "./utils/startup-profile";
import { getFrontendRelease } from "./utils/analytics/frontend-release";

// Initialize before evaluating App and its top-level analytics/router setup.
installRuntimePolyfills();
document.documentElement.dataset.frontendRelease = getFrontendRelease();
initializeSupportBrowserDiagnosticHistory();
initializeVitePreloadErrorRecovery();
initializeStartupProfiling();
// The preload recovery may reload the page for a vanished chunk; when it does
// not (repeat failure on the same build), this is the only thing on screen.
import("./renderJungleWebApp").catch(handleAppEntryImportFailure);
